import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import Error from '../../Error/error';
import cookie from 'react-cookies';
import {approveRole} from '../../../functions';
import { toast } from 'react-toastify';
import Moment from 'moment';
import {updateValueInJson, validateUrl, getRoles} from '../../../functions';
import $ from 'jquery';
import { getPagination, Pagination } from '../../Elements/Pagination/tablePagination';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default class Usuarios extends Component {
    state = {
        resource: [],
        response: [],
        error: [],
        security: cookie.load('user'),
        roles: [],

        filters: {
          nombre:     '',
          apellidoM:  '',
          apellidoP:  '',
          email:      ''
        },

        nombre:     '',
        apellidoM:  '',
        apellidoP:  '',
        email:      '',

        pagina: 1,
        offRows:0,

        menuGeneral:[],
        agrupador:  "",
    }

    resetFilters = () => {
      this.setState({
        nombre:     '',
        apellidoM:  '',
        apellidoP:  '',
        email:      ''
      });
    }

    changeFilter(e, name){
      const {value} = e.target;
      // let filters = this.state.filters;
      // filters[name] = value;

      this.setState({
        // filters: {...this.state.filters, [name]: value}
        [name]: value
      });
    }

    getData(page = "", filters = ""){
      console.log("page", page);

      let textSearch = "";
      if(filters !== ""){
        textSearch += "?"+filters;
      }

      if(page === ""){
        page = 1;
      }

      const url = `${API_URL}UsuarioUX/${page+textSearch}`;
      axios.get(url)
      .then(response => response.data)
      .then((data) => {

          this.setState({ 
            resource: data.result, 
            response: data, 
            error: data.Error, 
            // roles : roles, 
            pagina: page, 
          });

          // this.ShowPaginationFive(0);
          document.getElementById('content-wrapper').removeAttribute("hidden");
      })
      .catch(error => {
          console.log('Error de comunicación');
      });
    }

    /*
      paginationTable(){
        var entity = this.state.resource.length > 0 ? this.state.resource[0] : null;
        var maxPagination = 6;

        let actualpage    = this.state.pagina;
        let rango         = Number(maxPagination) + Number(actualpage);
        let totalPages    = "";

        const options = [];

        if (entity !== null){

            if(entity.totalPages == 1){
                return null;
            }

            if(rango > entity.totalPages){
              rango = Number(entity.totalPages);
              actualpage = Number(entity.totalPages) - Number(maxPagination);
            }

            if(actualpage < 1){
              actualpage = 1;
            }

            if(actualpage > 1 && rango > 7){
              options.push(
                <a 
                    id={`inicio-pag`} 
                    key={`inicio-pag`} 
                    onClick={(e) => this.getDataByFilter(e, `${1}`)}
                > 
                  ..
                </a>
              );
            }

            options.push(
                <a 
                    className="btnPrevPaginador" 
                    id={0} 
                    key={0} 
                    onClick={(e) => Number(this.state.pagina) <= 1 ? "" : this.getDataByFilter(e, `${Number(this.state.pagina) - 1}`)}
                ></a>
            );

            // console.log(index);
            // console.log(rango);

            for(let i = actualpage; i <= rango; i++){
                // console.log(i);

                options.push(
                    <a 
                        id={i} 
                        key={i} 
                        onClick={(e) => this.getDataByFilter(e, `${i}`)}
                        className={(i.toString() === this.state.pagina.toString() ? "active" : "") + " pageItem"}
                    > 
                        {i} 
                    </a>
                );
            }

            options.push(
                <a 
                    className="btnNextPaginador" 
                    id={entity.totalPages+1} 
                    key={entity.totalPages+1} 
                    onClick={(e) => entity.totalPages.toString() === this.state.pagina.toString() ? "" : this.getDataByFilter(e, `${Number(this.state.pagina) + 1}`)}
                ></a>
            );

            if(rango < entity.totalPages){
              options.push(
                <a 
                    id={entity.totalPages} 
                    key={entity.totalPages} 
                    onClick={(e) => this.getDataByFilter(e, `${entity.totalPages}`)}
                > 
                  ..
                </a>
              );
            }

            console.log(options);

            return (
                <div className="divPaginador" key={"pagination"} id="pagination">
                    {options}
                </div>
            );
        }
      }
    */

    getDataByFilter(e, page = ""){

      if(e !== null){
        e.preventDefault();
      }
      
      console.log(page);

      let textSearch = "";

      if(this.state.nombre){
        textSearch += `nombres=${this.state.nombre}`
      }

      if(this.state.apellidoP){
        if(textSearch !== ""){
          textSearch += "&";
        }
        textSearch += `apellidoPaterno=${this.state.apellidoP}`
      }

      if(this.state.apellidoM){
        if(textSearch !== ""){
          textSearch += "&";
        }
        textSearch += `apellidoMaterno=${this.state.apellidoM}`
      }

      if(this.state.email){
        if(textSearch !== ""){
          textSearch += "&";
        }
        textSearch += `email=${this.state.email}`
      }

      this.getData(page !== "" ? page : this.state.pagina, textSearch);
    }

    componentDidMount(){

      if($('#containerPanel').is("*")){
          $('#containerPanel').hide();
      }
      
      let newState = this.props.location.state;
      if(newState != undefined){  
          let sUrl = this.props.location.pathname;
          validateUrl(newState.menuGeneral, sUrl);     
          this.setState({
              menuGeneral: newState.menuGeneral,
              agrupador: newState.agrupador
          });            
      }else{
        this.setState({
          menuGeneral: this.props.menuGeneral,
          agrupador:   "Usuarios"
        }); 
      }
      

      this.getData("1");
    }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/permisos">
                            / Usuarios
                        </Link>
                        <span> / Lista de usuarios</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                  Usuarios
                </div>
                <div className="divSector_Panel">
                    <form action="" onSubmit={(e) => this.getDataByFilter(e, "1")}>
                      <div id='filters' className="divCatAnadir_Panel mb-3">
                          <div className="row align-items-end">
                            <div className="col-lg-3">
                              <a 
                                href="#" 
                                className="btnAnadir h-100 d-flex align-items-center justify-content-center" 
                                onClick={() => this.addUsuario()}
                              >
                                AÑADIR
                              </a>
                            </div>

                            <div className="col-lg-6">

                              <div className="row">

                                <div className="col-lg-6">
                                  <div className="mb-2">
                                    <input 
                                      type="text" 
                                      className='form-control form-control-sm-'
                                      placeholder='Nombre'
                                      // value={this.state.nombre}
                                      onChange={(e) => this.changeFilter(e, 'nombre')}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="mb-2">
                                    <input 
                                      type="text" 
                                      className='form-control form-control-sm-'
                                      placeholder='Apellido Paterno'
                                      // value={this.state.apellidoP}
                                      onChange={(e) => this.changeFilter(e, 'apellidoP')}
                                    />
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="mb-0">
                                    <input 
                                      type="text" 
                                      className='form-control form-control-sm-'
                                      placeholder='Apellido Materno'
                                      // value={this.state.apellidoM}
                                      onChange={(e) => this.changeFilter(e, 'apellidoM')}
                                    />
                                  </div>
                                </div>
                                
                                <div className="col-lg-6">
                                  <div className="mb-0">
                                    <input 
                                      type="text" 
                                      className='form-control form-control-sm-'
                                      placeholder='Correo Electrónico'
                                      // value={this.state.email}
                                      onChange={(e) => this.changeFilter(e, 'email')}
                                    />
                                  </div>
                                </div>

                              </div>

                            </div>

                            <div className="col-lg-3">
                              <div className="row">
                                <div className="col-12 mb-2">
                                  <button type='submit' className='btn btn-primary d-block w-100 py-1'>
                                    Buscar <i className='fa fa-search ml-2'></i>
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button 
                                    type='reset' 
                                    onClick={() => this.resetFilters()} 
                                    className='btn btn-secondary d-block w-100 py-1'
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="clear" />
                      </div>	
                    </form>

                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                          <tbody>
                              <tr>
                                  <th>Nombres</th>
                                  <th>Apellidos</th>
                                  <th>Correo Electrónico</th>
                                  <th>Fecha de Creación</th>
                                  <th>Acciones</th>
                              </tr>
                              {
                                  (this.state.response.statusCode===200) ?
                                    this.state.resource.map((resource, index) => (
                                      <tr key={"RowUsuario_" + index}>
                                          <td>{resource.sUsuNombre}</td>
                                          <td>{resource.sUsuApellidoPaterno + " " + resource.sUsuApellidoMaterno}</td>
                                          <td>{resource.sUsuEmail}</td>
                                          <td>
                                            {Moment(resource.dUsuFecCreacion).format('dddd DD, MMMM YYYY')}
                                          </td>
                                          <td>                                        
                                              <div className="divBtnAcciones">
                                                <OverlayTrigger
                                                  //key={placement}
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id={`tooltip-top-ver`}>
                                                      Ver
                                                    </Tooltip>
                                                  }
                                                >
                                                  <a 
                                                    className={resource.nUsuActivo ? "btnPageModuloVer" : "btnPageModuloInactivo"} 
                                                    onClick={(event) => this.actualizarEstado(resource)}
                                                  />
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                  //key={placement}
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id={`tooltip-top-editar`}>
                                                      Editar
                                                    </Tooltip>
                                                  }
                                                >
                                                  <a 
                                                    className="btnPageModuloEditar" 
                                                    onClick={(event) => this.editUsuario(resource.nUsuCodigo)}
                                                  />
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                  //key={placement}
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id={`tooltip-top-eliminar`}>
                                                      Eliminar
                                                    </Tooltip>
                                                  }
                                                >
                                                  <a 
                                                    className="btnPageModuloEliminar aEliminarMenu2"
                                                  />
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                  //key={placement}
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id={`tooltip-top-asign`}>
                                                      Asignar páginas
                                                    </Tooltip>
                                                  }
                                                >
                                                  <a 
                                                    onClick={(event) => this.asignPageToUser(resource.nUsuCodigo)}
                                                  >
                                                    <i className='fa fa-file'></i>
                                                  </a>
                                                </OverlayTrigger>
                                                
                                                <div className="c_divAlertaCapa">
                                                  <div className="divAlertaCapa">
                                                    <div className="divAlerta">
                                                      <h2>&iquest;Seguro de eliminar?</h2>
                                                      <div className="divAlertaBtn">
                                                        <a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarRegistro(resource)}>ACEPTAR</a>
                                                        <a href="#" className="btnAlertaCancelar">CANCELAR</a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                          </td>
                                      </tr>
                                    ))
                                  : 
                                    null
                              }
                          </tbody>
                        </table>
                    </div>

                    <Pagination
                      data={this.state.resource}
                      pagina={this.state.pagina}
                      changePage={(page) => this.getDataByFilter(null, page)}
                    />

                    <div className="clear" />
                </div>

            </div>
        )
    }
	
    editUsuario(id){
        this.props.history.push({
            pathname: '/editar-usuario/' + id,
            state: { key: id,
                menuGeneral:this.state.menuGeneral,
                agrupador:this.state.agrupador }
          });
    }

    asignPageToUser(id){
      this.props.history.push({
          pathname: '/listar-pagina/usuario/' + id,
          state: { key: id,
              menuGeneral:this.state.menuGeneral,
              agrupador:this.state.agrupador }
        });
    }

    addUsuario(){
        this.props.history.push({
            pathname: '/agregar-usuario/',
            state: { key: 0,
                menuGeneral:this.state.menuGeneral,
                agrupador:this.state.agrupador}
          });
    } 

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionButton(e);
        }
    }

    eliminarRegistro = async(entity) => {

        const url = `${API_URL}UsuarioUX/`;
        entity.nUsuActivo = !entity.nUsuActivo;

        entity.sectores = [
            {
              "nTipSector": "1"
            }
          ];
        entity.activo = true;

        let entityUpdate = {
            "nUsuCodigo": entity.nUsuCodigo,
            "nUsuTipoAutenticacion": 885,
            "nUsuTipoUsuario": 886,
            "sUsuNombre": entity.sUsuNombre,
            "sUsuApellidoPaterno": entity.sUsuApellidoPaterno,
            "sUsuApellidoMaterno": entity.sUsuApellidoMaterno,
            "sUsuEmail": entity.sUsuEmail,
            "sUsuContrasenia": "12345678",
            "nUbiCodigo": 1350,
            "sUsuDireccion": "",
            "sUsuCadenaActivacion": "",
            "sUsuTelefono": "",
            "sUsuCelular": "",
            "sectores": [
              {
                "nTipSector": "1"
              }
            ],
            "activo": true,
            //"nUsuCodModificacion":0,
            "nUsuEliminado":1
            //"nUsuActivo": entity.nUsuActivo
        }

        let dataToSave=updateValueInJson(entityUpdate, 'nUsuCodEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        setTimeout(() => { 
                            this.executePagination(this.state.pagina);
                        }, 1000);  
                    } else 
                    {
                        this.setState({loading:false});
                        toast.error('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    actualizarEstado = (entity) => {

        const url = `${API_URL}UsuarioUX/`;
        entity.nUsuActivo = !entity.nUsuActivo;

        entity.sectores = [
            {
              "nTipSector": "1"
            }
          ];
        entity.activo = true;

        let entityUpdate = {
            "nUsuCodigo": entity.nUsuCodigo,
            "nUsuTipoAutenticacion": 885,
            "nUsuTipoUsuario": 886,
            "sUsuNombre": entity.sUsuNombre,
            "sUsuApellidoPaterno": entity.sUsuApellidoPaterno,
            "sUsuApellidoMaterno": entity.sUsuApellidoMaterno,
            "sUsuEmail": entity.sUsuEmail,
            "sUsuContrasenia": "12345678",
            "nUbiCodigo": 1350,
            "sUsuDireccion": "",
            "sUsuCadenaActivacion": "",
            "sUsuTelefono": "",
            "sUsuCelular": "",
            "sectores": [
              {
                "nTipSector": "1"
              }
            ],
            "activo": entity.activo,
            "nUsuCodModificacion":0,
            "nUsuActivo": entity.nUsuActivo
        }
        
        let dataToSave=updateValueInJson(entityUpdate, 'nUsuCodModificacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {     
                    if (data.data.isSucess)
                    {
                        setTimeout(() => { 
                            this.executePagination(this.state.pagina);
                        }, 1000);  
                    } else 
                    {
                        this.setState({loading:false});
                        toast.error('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado.');
                this.setState({loading:false});
            });  
    }

    callFunctionButton = (event) => {

        var textoFilter = document.getElementById('texto_filter').value;
        // this.setState({filters:{texto: textoFilter}});

        //const url = (textoFilter != '') ? `${API_URL}UsuarioUX/1/${textoFilter}` : `${API_URL}UsuarioUX/1`;
        const url = `${API_URL}UsuarioUX/1`; //Temporal hasta la correccón de filtros de API (Miguel)

        axios.get(url).then(response => response.data)
        .then((data) => {
            this.setState({ resource: data.result, response: data, error: data.Error});
            document.getElementById('content-wrapper').removeAttribute("hidden");
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }
}
